var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEC"
    },
    points: "367.699,67.34 25.653,67.34 25.653,503.449 289.314,503.449 367.699,425.064 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.653,
    y: 67.34,
    style: {
      fill: "#D7D8D9"
    },
    width: 25.653,
    height: 436.109
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D7D8D9"
    },
    points: "289.67,503.449 367.699,425.42 289.67,425.42  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 102.614,
    y: 135.749,
    style: {
      fill: "#FDDD85"
    },
    width: 188.125,
    height: 128.267
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.614,
    y: 135.749,
    style: {
      fill: "#FDD042"
    },
    width: 76.96,
    height: 128.267
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.267,
    y: 135.749,
    style: {
      fill: "#E1A527"
    },
    width: 25.653,
    height: 51.307
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5563C"
    },
    d: "M245.052,41.687c-7.045-19.925-26.038-34.205-48.376-34.205S155.346,21.762,148.3,41.687h-28.584 v59.858h153.921V41.687H245.052z M196.676,67.34c-9.446,0-17.102-7.656-17.102-17.102s7.656-17.102,17.102-17.102 c9.446,0,17.102,7.656,17.102,17.102S206.122,67.34,196.676,67.34z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CF442B"
    },
    points: "136.818,84.443 136.818,41.687 119.716,41.687 119.716,101.545 273.637,101.545  273.637,84.443 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B9DA1"
    },
    d: "M419.006,503.449h17.102c9.446,0,17.102-7.656,17.102-17.102V161.403h-51.307v324.944 C401.904,495.792,409.56,503.449,419.006,503.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5563C"
    },
    d: "M419.006,503.449h17.102c9.446,0,17.102-7.656,17.102-17.102V366.63h-51.307v119.716 C401.904,495.792,409.56,503.449,419.006,503.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88898E"
    },
    d: "M419.006,486.347V161.403h-17.102v324.944c0,9.446,7.656,17.102,17.102,17.102h17.102 C426.663,503.449,419.006,495.792,419.006,486.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF442B"
    },
    d: "M419.006,486.347V366.63h-17.102v119.716c0,9.446,7.656,17.102,17.102,17.102h17.102 C426.663,503.449,419.006,495.792,419.006,486.347z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDD042"
    },
    points: "401.904,161.403 453.211,161.403 427.557,92.994 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.699,59.858h-86.58V41.687c0-4.427-3.054-7.482-7.482-7.482h-23.214C240.754,12.827,219.828,0,196.676,0 s-44.078,12.827-53.746,34.205h-23.214c-4.428,0-8.551,3.055-8.551,7.482v18.171H25.653c-4.428,0-8.551,3.055-8.551,7.482v436.109 c0,4.427,4.123,8.551,8.551,8.551h263.661c2.101,0,4.183-1.13,5.669-2.616l78.118-78.519c1.486-1.486,2.08-3.702,2.08-5.802V221.261 c0-4.427-3.588-8.017-8.017-8.017c-4.428,0-8.017,3.589-8.017,8.017v195.608h-69.834c-4.428,0-8.195,3.767-8.195,8.195v70.903 H33.136V75.891h78.029v25.653c0,4.427,4.123,8.551,8.551,8.551h153.921c4.428,0,7.482-4.124,7.482-8.551V75.891h78.029v111.165 c0,4.427,3.588,8.017,8.017,8.017c4.428,0,8.017-3.589,8.017-8.017V67.34C375.182,62.913,372.128,59.858,367.699,59.858z  M348.346,432.902l-51.194,51.193v-51.193H348.346z M265.086,94.063H127.198V50.238H148.3c3.398,0,6.426-2.408,7.558-5.612 c6.103-17.262,22.507-28.994,40.818-28.994s34.714,11.798,40.818,29.061c1.133,3.203,4.161,5.545,7.558,5.545h20.033V94.063z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.29,324.944H196.676c-4.428,0-8.017,3.589-8.017,8.017c0,4.427,3.588,8.017,8.017,8.017H299.29 c4.428,0,8.017-3.589,8.017-8.017C307.307,328.533,303.719,324.944,299.29,324.944z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.29,359.148H196.676c-4.428,0-8.017,3.589-8.017,8.017c0,4.427,3.588,8.017,8.017,8.017H299.29 c4.428,0,8.017-3.589,8.017-8.017C307.307,362.738,303.719,359.148,299.29,359.148z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.29,393.353H196.676c-4.428,0-8.017,3.589-8.017,8.017c0,4.427,3.588,8.017,8.017,8.017H299.29 c4.428,0,8.017-3.589,8.017-8.017C307.307,396.942,303.719,393.353,299.29,393.353z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.165,323.875h51.307c4.428,0,8.017-3.589,8.017-8.017c0-4.427-3.588-8.017-8.017-8.017h-26.722v-9.62 c0-4.427-3.588-8.017-8.017-8.017c-4.428,0-8.017,3.589-8.017,8.017v9.62h-8.551c-13.851,0-25.653,10.734-25.653,24.585v17.102 c0,13.851,11.803,25.653,25.653,25.653h34.205c5.01,0,8.551,3.541,8.551,8.551v17.102c0,5.01-3.541,9.62-8.551,9.62H94.063 c-4.428,0-8.017,3.589-8.017,8.017c0,4.427,3.588,8.017,8.017,8.017h25.653v8.551c0,4.427,3.588,8.017,8.017,8.017 c4.428,0,8.017-3.589,8.017-8.017v-8.551h9.62c13.851,0,24.585-11.803,24.585-25.653v-17.102c0-13.851-10.734-24.585-24.585-24.585 h-34.205c-5.01,0-9.62-4.61-9.62-9.62v-17.102C101.545,327.416,106.155,323.875,111.165,323.875z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.221,136.284c0-4.427-3.589-8.017-8.017-8.017H102.079c-4.427,0-8.017,3.589-8.017,8.017v128.267 c0,4.427,3.589,8.017,8.017,8.017h188.125c4.427,0,8.017-3.589,8.017-8.017V136.284z M282.188,256.534h-95.132V144.301h95.132 V256.534z M145.37,144.301v35.273h-9.62v-35.273H145.37z M110.096,256.534V144.301h9.62v42.756c0,4.427,4.123,8.551,8.551,8.551 h25.653c4.428,0,7.482-4.124,7.482-8.551v-42.756h9.62v112.234H110.096z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.779,178.505h51.307c4.428,0,8.017-3.589,8.017-8.017s-3.588-8.017-8.017-8.017h-51.307 c-4.428,0-8.017,3.589-8.017,8.017S209.35,178.505,213.779,178.505z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.175,218.193c-1.235-3.093-4.478-5.107-7.791-4.939c-3.494,0.177-6.523,2.67-7.379,6.057 c-1.786,7.079,6.542,12.757,12.479,8.436C221.441,225.596,222.598,221.574,221.175,218.193z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.829,218.193c-1.211-3.035-4.344-5.027-7.594-4.944c-3.269,0.083-6.256,2.222-7.349,5.31 c-1.119,3.165-0.128,6.763,2.463,8.895c2.688,2.214,6.634,2.406,9.529,0.476C247.013,225.841,248.293,221.674,246.829,218.193z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.493,218.193c-2.689-6.391-12.158-6.499-14.815,0c-1.323,3.237-0.373,7.041,2.325,9.262 c2.579,2.124,6.318,2.396,9.184,0.689C272.587,226.121,273.95,221.845,272.493,218.193z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.714,214.591c-3.027-2.042-7.218-1.689-9.887,0.786c-2.303,2.136-3.161,5.516-2.137,8.486 c1.103,3.202,4.186,5.409,7.577,5.416c3.389,0.006,6.477-2.222,7.577-5.416C137.026,220.434,135.684,216.625,132.714,214.591z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.328,218.193c-2.7-6.416-12.123-6.49-14.815,0c-1.354,3.265-0.339,7.179,2.442,9.362 c2.587,2.031,6.24,2.268,9.064,0.589C161.423,226.123,162.786,221.846,161.328,218.193z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.676,25.119c-13.851,0-25.119,11.268-25.119,25.119s11.268,25.119,25.119,25.119c13.851,0,25.119-11.268,25.119-25.119 S210.527,25.119,196.676,25.119z M196.676,59.324c-5.01,0-9.086-4.076-9.086-9.086s4.076-9.086,9.086-9.086 c5.01,0,9.086,4.076,9.086,9.086S201.686,59.324,196.676,59.324z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M486.881,341.511c-4.428,0-8.017,3.589-8.017,8.017v102.614c0,5.01-3.541,9.62-8.551,9.62h-8.551 c-0.181,0,0-0.519-1.069-0.508V161.403c0-0.949-0.175-1.926-0.511-2.814L435.04,91.54v-24.2c0-4.427-3.588-8.017-8.017-8.017 s-8.017,3.589-8.017,8.017v24.2l-25.143,67.048c-0.335,0.889-0.511,1.865-0.511,2.814v324.944c0,13.851,11.803,25.653,25.653,25.653 h17.102c13.851,0,24.585-11.803,24.585-25.653v-9.112c1.069,0.012,0.888,0.561,1.069,0.561h8.551 c13.851,0,24.585-11.803,24.585-25.653V349.528C494.898,345.101,491.309,341.511,486.881,341.511z M444.66,359.148h-35.273V169.954 h35.273V359.148z M427.557,116.36l14.086,37.561h-28.171L427.557,116.36z M444.66,486.347c0,5.01-3.541,9.62-8.551,9.62h-17.102 c-5.01,0-9.62-4.61-9.62-9.62V375.182h35.273V486.347z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M420.149,207.226c1.228,2.903,4.082,4.875,7.242,4.946c3.409,0.076,6.561-2.108,7.707-5.312 c1.167-3.261,0.051-7-2.707-9.092c-2.582-1.957-6.173-2.125-8.95-0.476C420.045,199.309,418.694,203.584,420.149,207.226z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M427.557,237.829c3.391,0,6.476-2.218,7.577-5.416c1.115-3.236-0.021-6.926-2.745-8.992 c-5.892-4.469-14.436,1.173-12.601,8.358C420.686,235.288,423.931,237.829,427.557,237.829z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M420.149,258.533c1.228,2.903,4.082,4.875,7.242,4.946c3.411,0.076,6.558-2.109,7.707-5.311 c1.165-3.246,0.06-7.016-2.707-9.088c-2.6-1.946-6.157-2.138-8.95-0.479C420.045,250.616,418.694,254.891,420.149,258.533z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M427.023,331.891c4.428,0,8.017-3.589,8.017-8.017v-42.756c0-4.427-3.588-8.017-8.017-8.017s-8.017,3.589-8.017,8.017 v42.756C419.006,328.302,422.595,331.891,427.023,331.891z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.679a27eccb6355be22bd128a6f607666.svg";
export { ForwardRef as ReactComponent };